import { Home } from "../../components/backgrounds/Home";
import { Feature } from "../../components/home/Feature"

export function ComoFuncionaPage() {
  return (
    <>
      <Home title={"Cómo funciona"} />
      <Feature/>
    </>
  );
}
